// 時代区分の定義
export const eras = [
  { id: 'ancient', name: '古代', year: '〜500' }, 
  { id: 'medieval', name: '中世', year: '501-1500' }, 
  { id: 'early-modern', name: '近世', year: '1501-1800' }, 
  { id: 'modern', name: '近代', year: '1801-1945' }, 
  { id: 'contemporary', name: '現代', year: '1945-' }
];
